import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import InputForm from "src/component/common/CommonForm/InputForm";
import { CustomBtn } from "src/styles/common/CommonForm/buttonform";
import RefundSelect from "src/component/Refund/RefundSelect";
import Modal from "src/component/common/Modal/Modal";
import useWindowDimensions from "src/hooks/useGetWindowSize";
import Loading from "src/component/common/Loading";
import useValid from "src/hooks/useValid";
import {
  CertNumState,
  DouModalOption,
  TelNumState,
} from "src/store/recoil/common";
import { COLOR } from "src/service/constant/color";
import useOnInput from "src/hooks/useOnInput";
import useSubscriptQuery from "src/hooks/useSubscriptQuery";
import {
  RefundCaution,
  RefundWrap,
  SubScriptTitle,
  SubScriptDesc,
} from "src/styles/views/Support/refund";
import { SubScriptContent, SubScriptWrap } from "src/styles/common/subscript";
import { validInputLength } from "src/service/utils";
import DoubleModal from "src/component/common/Modal/DoubleModal";
import { InputDataListType } from "src/types/type";
import {
  RefundAccount,
  RefundName,
  RefundTermYN,
  RefundTypeState,
  useRefundResetCallback,
} from "src/store/recoil/refund";
import RefundTerms from "src/component/Refund/RefundTerm";

const Refund = () => {
  const { width } = useWindowDimensions();
  const valid = useValid();
  const onInput = useOnInput();

  const TelNum = useRecoilValue(TelNumState);
  const CertNum = useRecoilValue(CertNumState);
  const RefundType = useRecoilValue(RefundTypeState);
  const RefundTermYNState = useRecoilValue(RefundTermYN);
  const RefundNameState = useRecoilValue(RefundName);
  const RefundAccountState = useRecoilValue(RefundAccount);
  const DouModalSetting = useRecoilValue(DouModalOption);

  const resetCallback = useRefundResetCallback();

  const {
    securityCheck,
    refund,
    openRefundModal,
    RefundIsLoading,
    douIsOpen,
    modalSetting,
    isOpen,
    douToggle,
    toggle,
  } = useSubscriptQuery();

  const SubmitCondition =
    TelNum[0].check &&
    !validInputLength(CertNum, 4) &&
    RefundType !== "none" &&
    RefundAccountState[0].check &&
    RefundNameState[0].check &&
    RefundTermYNState;

  const InputDataList: InputDataListType[] = [
    {
      title: "계좌번호 입력",
      valid: valid.RefundAccountValid,
      check: RefundAccountState[0].check,
      oninput: onInput.RefundAccount,
      placeholder: "계좌번호를 입력해주세요.",
      errMsg: "계좌번호를 정확히 입력해주세요.",
      blurFunc: valid.onBlurForValidationAccount,
    },
    {
      title: "예금주명 입력",
      valid: valid.RefundNameValid,
      check: RefundNameState[0].check,
      oninput: onInput.InquiryName,
      placeholder: "예금주명을 입력해주세요.",
      errMsg: "이름을 정확히 입력해주세요.",
      blurFunc: valid.onBlurForValidationString,
    },
  ];

  useEffect(() => {
    return () => {
      resetCallback();
    }
  }, [resetCallback]);

  return (
    <RefundWrap>
      {RefundIsLoading && <Loading />}
      <SubScriptWrap>
        <SubScriptTitle>
          서비스 환불을 신청하기 전에 아래 내용을 꼭 확인해 주세요.
        </SubScriptTitle>
        <SubScriptDesc>
          <p>
            <span>
              <span className="warning">
                * 서비스 이용 이력이 없을 경우 환불이 가능합니다.
              </span>
              <br />* 환불 신청 시 서비스는 자동으로 해지됩니다.
            </span>
          </p>
        </SubScriptDesc>
        <SubScriptContent>
          <InputForm
            title="휴대폰 번호"
            valid={valid.PhoneNumValid}
            check={TelNum[0].check}
            placeholder="‘-’을 제외하고 입력해주세요."
            ClickFunc={securityCheck}
            oninput={onInput.PhoneNum}
          />
          <InputForm
            title="인증번호 입력"
            value={CertNum}
            valid={valid.CertNumValid}
            oninput={onInput.CertNum}
            placeholder="인증번호를 입력해주세요."
            blurFunc={valid.onBlurForValidationCert}
            errMsg="인증문자 입력을 확인해주세요."
          />

          <RefundSelect title="환불 받을 은행 선택" />
          {InputDataList?.map((element: InputDataListType) => (
            <InputForm
              title={element.title}
              value={element.value}
              valid={element.valid}
              check={element.check}
              oninput={element.oninput}
              placeholder={element.placeholder}
              key={element.title}
              blurFunc={element.blurFunc}
              errMsg={element.errMsg}
            />
          ))}
        </SubScriptContent>
      </SubScriptWrap>
      <RefundTerms />
      <CustomBtn
        color={COLOR.white}
        bgColor={SubmitCondition ? COLOR.point1 : COLOR.gray30}
        borderRadius={"40px"}
        marginTop={width > 1200 ? "64px" : "56px"}
        width={width > 360 ? "356px" : "328px"}
        height={width > 1200 ? "56px" : "44px"}
        fontSize={width > 1200 ? "18px" : "14px"}
        fontFamily={
          width > 1200
            ? "NanumSquareNeoHeavy, sans-serif"
            : "NotoSansBold, sans-serif"
        }
        onClick={refund}
      >
        <span>서비스 해지 후 환불 등록</span>
      </CustomBtn>
      <RefundCaution>
        *가입 당일 해지하신 고객님은 요금이 청구되지 않습니다. <br />
        서비스 이용요금은 매월 사용일 수 만큼 계산되어 청구됩니다.
      </RefundCaution>
      <Modal
        isOpen={isOpen}
        type={modalSetting.type}
        toggle={toggle}
        doubleToggle={douToggle}
        setOption={modalSetting.setOption}
        option={modalSetting.option}
        ClickFunc={toggle}
        ClickFunc2={douToggle}
        ClickFunc3={openRefundModal}
      />
      <DoubleModal
        isOpen={douIsOpen}
        toggle={toggle}
        toggle2={douToggle}
        option={DouModalSetting}
      />
    </RefundWrap>
  );
};
export default Refund;
